import { LegalPage } from "@/components/common/LegalPage";
import { termsSections, LEGAL_UPDATED } from "@/data/legal.data";

export default function Terms() {
  return (
    <LegalPage
      title="Terms of Service"
      seoTitle="Terms of Service"
      seoDescription="Read the VibeWell terms of service governing use of our website and services."
      path="/terms"
      updated={LEGAL_UPDATED}
      intro="The terms and conditions for using VibeWell's website and services."
      sections={termsSections}
    />
  );
}
